import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

// Daily credits left for the logged-in user. Loaded on mount; analyses and
// chat replies report the new count through setCreditsRemaining.
export const useCredits = () => {
  const { isLoggedIn, authFetch } = useAuth();
  const [creditsRemaining, setCreditsRemaining] = useState(null);

  useEffect(() => {
    const fetchCredits = async () => {
      if (!isLoggedIn) return;
      try {
        // /credits replies with `remaining`; /analyze and chat use `credits_remaining`
        const data = await authFetch('/credits');
        if (data.remaining !== undefined) {
          setCreditsRemaining(data.remaining);
        }
      } catch (err) {
        console.error("Failed to fetch credits:", err);
      }
    };
    fetchCredits();
  }, [authFetch, isLoggedIn]);

  return { creditsRemaining, setCreditsRemaining };
};
